export const RATING = ["ZERO_STAR", "ONE_STAR", "TWO_STARS", "THREE_STARS", "FOUR_STARS", "FIVE_STARS"];
export const RATING_LABELS = [
  {
    id: "respect",
    propertyName: "respectRating",
    label: "user-respect-rating"
  },
  {
    id: "communication",
    propertyName: "communicationRating",
    label: "user-communication-rating"
  },
  {
    id: "user-overall",
    propertyName: "overallRating",
    label: "user-overall-experience-rating"
  },
  {
    id: "compliance",
    propertyName: "complianceRating",
    label: "ad-compliance-rating"
  },
  {
    id: "quality",
    propertyName: "qualityRating",
    label: "ad-quality-rating"
  },
  {
    id: "ad-overall",
    propertyName: "overallRating",
    label: "ad-overall-experience-rating"
  }
];
